var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeadingBold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M18.7001 7.68324L13.9001 4.32491C12.5918 3.40824 10.5834 3.45824 9.32511 4.43324L5.15011 7.69157C4.31678 8.34157 3.65845 9.67491 3.65845 10.7249V16.4749C3.65845 18.5999 5.38345 20.3332 7.50845 20.3332H16.4918C18.6168 20.3332 20.3418 18.6082 20.3418 16.4832V10.8332C20.3418 9.70824 19.6168 8.32491 18.7001 7.68324Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 17.625C11.6583 17.625 11.375 17.3417 11.375 17V14.5C11.375 14.1583 11.6583 13.875 12 13.875C12.3417 13.875 12.625 14.1583 12.625 14.5V17C12.625 17.3417 12.3417 17.625 12 17.625Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeadingBold);
export default __webpack_public_path__ + "static/media/leading-bold.9f1c814b62d4429b16dad52da4460a60.svg";
export { ForwardRef as ReactComponent };